import { supabase } from './supabase'
import type { Profile } from '../types'

const morningOrigin = 'https://morning-bite.pages.dev'
export function connectMorning(onLogin: (profile: Profile) => void, onError: (message: string) => void) {
  const opener = window.opener
  let disposed = false, accepting = false
  const nonce = Array.from(crypto.getRandomValues(new Uint8Array(24))).map(n => n.toString(16).padStart(2, '0')).join('')
  const fail = (message: string) => {
    if (disposed) return
    onError(message)
    opener?.postMessage({ type: 'morning-gallery-error', nonce }, morningOrigin)
    cleanup()
  }
  const timer = setTimeout(() => fail('연결 시간이 지났어요. 아침한입에서 다시 열어 주세요.'), 90000)
  function cleanup() { disposed = true; clearTimeout(timer); window.removeEventListener('message', receive) }
  async function receive(event: MessageEvent) {
    if (disposed || event.source !== opener || event.origin !== morningOrigin || event.data?.nonce !== nonce) return
    if (event.data.type === 'morning-gallery-error') { fail(typeof event.data.message === 'string' ? event.data.message : '아침한입에서 다시 열어 주세요.'); return }
    if (event.data.type !== 'morning-gallery-ticket' || accepting || typeof event.data.ticket !== 'string' || !/^[a-f0-9]{64}$/.test(event.data.ticket)) return
    accepting = true
    try {
      if (!supabase) throw Error('전시관 연결 설정을 확인해 주세요.')
      const { data, error } = await supabase.functions.invoke('morning-login', { body: { ticket: event.data.ticket, nonce } })
      if (disposed) return
      if (error || !data?.tokenHash) throw Error(data?.message || '로그인 연결에 실패했어요. 아침한입에서 다시 열어 주세요.')
      const verified = await supabase.auth.verifyOtp({ token_hash: data.tokenHash, type: 'magiclink' })
      if (disposed) return
      if (verified.error || verified.data.user?.id !== data.profileId) throw Error('연결된 학생을 확인하지 못했어요.')
      const result = await supabase.from('profiles').select('id,display_name,role,avatar_color').eq('id', data.profileId).single()
      if (disposed) return
      if (result.error || result.data?.role !== 'student') throw Error('학생 계정을 확인하지 못했어요.')
      const profile = result.data
      opener.postMessage({ type: 'morning-gallery-complete', nonce }, morningOrigin)
      // URL contains only the flow marker, never a session or one-time credential.
      history.replaceState(null, '', location.pathname + location.search)
      window.opener = null
      cleanup()
      onLogin({ id: profile.id, displayName: profile.display_name, role: profile.role, avatarColor: profile.avatar_color })
    } catch (error) { fail(error instanceof Error ? error.message : '로그인하지 못했어요.') }
  }
  window.addEventListener('message', receive)
  queueMicrotask(() => {
    if (disposed) return
    if (!opener) fail('아침한입 학생 화면에서 배움전시관 열기를 눌러 주세요.')
    else opener.postMessage({ type: 'morning-gallery-ready', nonce }, morningOrigin)
  })
  return cleanup
}
